import React, { useState } from "react";

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Dohvati CSRF token
      await fetch("/reservations/api/auth/csrf/");

      const response = await fetch("/reservations/api/auth/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data);
      } else {
        setError(data.error || "Greška pri prijavi.");
      }
    } catch {
      setError("Mrežna greška – pokušaj ponovo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="bg-gray-900 border border-[#c1b428] rounded-xl shadow-2xl p-8 w-80">
        
        <div className="flex justify-center mb-6">
          <img src="/thehousepub_logo.jpg" alt="Logo" className="w-32 rounded-lg" />
        </div>

        <h2 className="text-[#c1b428] font-bold text-center text-lg mb-6">
          Prijava
        </h2>

        {error && (
          <div className="mb-4 p-2 bg-red-900 border border-[#c1b428] rounded text-[#c1b428] text-xs text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[#c1b428] text-xs mb-1">Korisničko ime:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-gray-800 text-white border border-[#c1b428] rounded px-3 py-2 text-sm"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-[#c1b428] text-xs mb-1">Lozinka:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-gray-800 text-white border border-[#c1b428] rounded px-3 py-2 text-sm"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#c1b428] text-black font-bold rounded py-2 text-sm hover:bg-yellow-500 disabled:opacity-50"
          >
            {loading ? "Prijava..." : "Prijavi se"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;